module.exports = __webpack_public_path__ + "static/media/logo192.429731a9.jpg";